/**
 * EBH 2026-09-14 — substituição nativa do Selleasy (ficha de produto + gaveta
 * do carrinho). Ver theme_fixes/selleasy_nativo_2026-09-14/.
 *
 * Ficheiro à parte, não integrado no bundle theme.min.js: o tema não expõe as
 * suas funções internas de carrinho/carrossel em `window`, por isso este
 * ficheiro fala só com o que É público — os endpoints /cart/*.js do Shopify,
 * o evento de DOM "apps:product-added-to-cart" (o mesmo que o quick-cart já
 * escuta para se atualizar) e o ícone do carrinho no cabeçalho (para o abrir).
 * O carrossel usa o MESMO chunk do Swiper que o tema já carrega
 * (window.flu.chunks.swiper), só para não duplicar a biblioteca.
 *
 * Delegação de eventos em document: a gaveta do carrinho substitui o seu
 * próprio innerHTML de cada vez que se atualiza (refreshQuickCart), por isso
 * um listener preso a um elemento concreto perder-se-ia — delegar em
 * document sobrevive a isso sem precisar de saber quando o carrinho mudou.
 */
(function () {
  "use strict";

  var CART_ICON_SELECTOR = "[data-js-cart-icon=\"cart\"]";

  function money(cents) {
    if (window.theme && window.theme.moneyFormat) {
      return window.theme.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }
    return (cents / 100).toFixed(2);
  }

  function notifyCartUpdated() {
    document.dispatchEvent(new CustomEvent("apps:product-added-to-cart"));
  }

  function openCartDrawer() {
    var icon = document.querySelector(CART_ICON_SELECTOR);
    if (icon) icon.click();
  }

  function addItems(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json();
    });
  }

  // ── ficha de produto: total dinâmico + botão "Add bundle to cart" ──────

  function updateBundleTotal(builder) {
    var total = 0;
    var triggerPrice = builder.querySelector("[data-ebh-bundle-price]");
    if (triggerPrice) total += parseInt(triggerPrice.dataset.salePrice, 10) || 0;

    var checked = builder.querySelectorAll("[data-ebh-bundle-checkbox]:checked");
    checked.forEach(function (box) {
      total += parseInt(box.dataset.salePrice, 10) || 0;
    });

    var totalEl = builder.querySelector("[data-ebh-bundle-total]");
    if (totalEl) totalEl.textContent = money(total);
  }

  document.addEventListener("change", function (event) {
    var checkbox = event.target.closest("[data-ebh-bundle-checkbox]");
    if (!checkbox) return;
    var builder = checkbox.closest("[data-ebh-bundle-mode=\"builder\"]");
    if (builder) updateBundleTotal(builder);
  });

  document.addEventListener("click", function (event) {
    var addButton = event.target.closest("[data-ebh-bundle-add]");
    if (!addButton) return;
    event.preventDefault();

    var builder = addButton.closest("[data-ebh-bundle-mode=\"builder\"]");
    if (!builder || addButton.classList.contains("is-loading")) return;

    var items = [{ id: parseInt(addButton.dataset.triggerVariantId, 10), quantity: 1 }];
    builder.querySelectorAll("[data-ebh-bundle-checkbox]:checked").forEach(function (box) {
      items.push({ id: parseInt(box.value, 10), quantity: 1 });
    });

    addButton.classList.add("is-loading");
    addItems(items)
      .then(function () {
        notifyCartUpdated();
        openCartDrawer();
      })
      .finally(function () {
        addButton.classList.remove("is-loading");
      });
  });

  // ── gaveta do carrinho: botão "Add" individual por cartão ───────────────

  document.addEventListener("click", function (event) {
    var quickAdd = event.target.closest("[data-ebh-bundle-quick-add]");
    if (!quickAdd || quickAdd.classList.contains("is-loading")) return;
    event.preventDefault();

    quickAdd.classList.add("is-loading");
    addItems([{ id: parseInt(quickAdd.dataset.variantId, 10), quantity: 1 }])
      .then(function () {
        notifyCartUpdated();
      })
      .finally(function () {
        quickAdd.classList.remove("is-loading");
      });
  });

  // ── carrossel (gaveta do carrinho) — reaproveita o chunk do Swiper ──────

  var activeSwipers = new WeakMap();

  function initSliders(root) {
    var sliders = root.querySelectorAll("[data-ebh-bundle-slider]");
    if (!sliders.length) return;
    if (!(window.flu && window.flu.chunks && window.flu.chunks.swiper)) return;

    import(window.flu.chunks.swiper).then(function (mod) {
      sliders.forEach(function (node) {
        if (activeSwipers.has(node)) return;
        var next = node.querySelector("[data-next]");
        var prev = node.querySelector("[data-prev]");
        var swiper = new mod.Swiper(node, {
          slidesPerView: 2.2,
          spaceBetween: 8,
          grabCursor: true,
          watchSlidesProgress: true,
          modules: [mod.Navigation],
          navigation: prev && next ? { nextEl: next, prevEl: prev } : undefined
        });
        activeSwipers.set(node, swiper);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initSliders(document);
  });

  // A gaveta do carrinho substitui `.quick-cart__items` inteiro sempre que se
  // atualiza (ver refreshQuickCart em theme.min.js) — por isso um carrossel
  // novo pode aparecer sem nenhum evento de DOM "carregado" a avisar.
  var quickCartItems = document.querySelector(".quick-cart__items");
  if (quickCartItems && "MutationObserver" in window) {
    new MutationObserver(function () {
      initSliders(quickCartItems);
    }).observe(quickCartItems, { childList: true, subtree: false });
  }

  initSliders(document);
})();
